module.exports = __webpack_public_path__ + "img/nu_renunta.5a29a197.png";